import React from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';

export const HeaderText = ({ children, className }) => (
  <h1 className={`mt-0 ${className}`}>{children}</h1>
);

export const Underline = ({ children, className }) => (
  <span className={`${styles.underline} ${className}`}>{children}</span>
);

const MainHeader = ({
  header,
  subtext,
  subtextClassName,
  textOnly,
  onButtonClick,
  buttonText,
  buttonClassName,
  autoplayVideo,
  image,
  videoElement,
  videoElementContainerClassName,
  children,
  containerClassName,
  flip,
  form,
  style,
}) => (
  <section className={`${styles.mainBanner} ${style || ''}`}>
    <div className="container">
      <div className="row">
        <div
          className={`col-12 d-flex flex-column ${textOnly ? '' : 'align-items-start'}`}
        >
          <div
            className={classNames({
              'd-flex flex-column align-items-center w-100 flex-lg-row': true,
              'justify-content-center': textOnly,
            })}
          >
            {form && (
              <div className="order-lg-2 w-100 d-none d-lg-flex">{form}</div>
            )}
            <div
              className={`${styles.bannerText} ${flip ? 'order-lg-2' : 'order-lg-1'}`}
            >
              {header}
              <div className={styles.desktopSubtextContainer}>
                <p className={`order-2 order-lg-1 ${subtextClassName}`}>
                  {subtext}
                </p>
                {buttonText && (
                  <button
                    onClick={onButtonClick}
                    className={`w-100 order-1 order-lg-2 ${buttonClassName}`}
                  >
                    {buttonText}
                  </button>
                )}
              </div>
            </div>
            {autoplayVideo && (
              <video
                className={`${styles.video} ${flip ? 'order-lg-1' : 'order-lg-2'}`}
                autoplay="true"
                muted="true"
                loop="true"
                playsinline="true"
                src={autoplayVideo}
              />
            )}
            {!autoplayVideo && image && (
              <div
                className={`${flip ? 'order-lg-1 pr-lg-5' : 'order-lg-2 pl-lg-5'} ${styles.imgContainer}`}
              >
                <img src={image} />
              </div>
            )}
            {!autoplayVideo && !image && videoElement && (
              <div
                className={`${flip ? 'order-lg-1' : 'order-lg-2'} ${videoElementContainerClassName}`}
              >
                {videoElement}
              </div>
            )}
            {!autoplayVideo && !image && !videoElement && children && (
              <div
                className={`${flip ? 'order-lg-1 pr-lg-5' : 'order-lg-2 pl-lg-5'} ${styles.customContent} ${containerClassName}`}
              >
                {children}
              </div>
            )}
          </div>
          <div className={styles.mobileSubtextContainer}>
            {buttonText && (
              <button
                onClick={onButtonClick}
                className={`w-100 order-1 order-lg-2 ${buttonClassName}`}
              >
                {buttonText}
              </button>
            )}
            <p className={`order-2 order-lg-1 ${subtextClassName}`}>
              {subtext}
            </p>
            {form && <div className="mt-5 pb-md-3">{form}</div>}
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default MainHeader;
